import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  Output,
  EventEmitter,
  inject,
  TemplateRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzInputModule } from 'ng-zorro-antd/input';
import { BaseComponent } from '../../../../shared/utils/base.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { CommonModule, DatePipe } from '@angular/common';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { STATIC_JSON_DATA_PATH } from '../../../../shared/constants/static-data.constants';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { SectionsService } from '../../../../services/sections.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { GridAction } from '../../../../shared/components/list-table/grid-action.model';
import { ListService } from '../../../../shared/services/list.service';
import { AuthorizationsDetailsService } from '../../../../services/authorizations-service.service';
import { performValidation } from '../../../../shared/utils/validation.util';
import { LoggerService } from '../../../../shared/services/logger.service';
import { SharedService } from '../../../../shared/services/shared.service';
import { FileUploadComponent } from '../../../lead-details/documents/file-upload/file-upload/file-upload.component';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { ClaimsService } from '../../../../services/claims.service';
import { DialogService, DialogConfig } from '../../../../shared/services/dialog.service';
import { SearchAddDiagnosisCodeComponent } from '../search-add-diagnosis-code/search-add-diagnosis-code.component';
import { UserService } from '../../../../services/user.service';
import { DatePickerComponent } from '../../../../shared/components/date-picker/date-picker.component';
import { FocusTrapDirective } from '../../../../shared/directives/focus-trap.directive';
import { DropdownSelectComponent } from '../../../../shared/components/dropdown-select/dropdown-select.component';
@Component({
  selector: 'ppl-auth-forms',
  standalone: true,
  imports: [
    ButtonComponent,
    NzFormModule,
    ReactiveFormsModule,
    FormsModule,
    NzCardModule,
    NzInputModule,
    NzToolTipModule,
    CommonModule,
    NzDatePickerModule,
    NzToolTipModule,
    NzSelectModule,
    NzButtonModule,
    NzCollapseModule,
    NzAutocompleteModule,
    ListTableComponent,
    FileUploadComponent,
    SearchAddDiagnosisCodeComponent,
    DatePickerComponent,
    FocusTrapDirective,
    DropdownSelectComponent
  ],
  providers: [ListService],
  templateUrl: './auth-forms.component.html',
  styleUrl: './auth-forms.component.css',
})
export class AuthFormsComponent
  extends BaseComponent
  implements OnInit, OnChanges
{
  authorizationsForm!: FormGroup;
  providerTypes: any;
  pageTitle = 'Add Authorization';
  mode = 'read';
  savedData: any = {};
  isNew = true;
  isConsumerSelected = false;
  showConsumersList = false;
  programName!: string;
  columnsToBeHidden: any;
  sharedDataKey: any;
  actionsToBeHidden: any;
  lazyLoad = true;
  cols: any[] = [];
  authCols: any[] = [];
  flow: string | null = '';
  selectedConsumer: any;
  selectedAuth: any;
  showSearchError = false;
  mcoEntries: any =[];
  showAddedAuths = false;
  modifiersList: any;
  serviceCodesList: any = [];
  authsInSession: any[] = [];
  filedInfo: any;
  selectedLead = 0;
  savedAuthId: any;
  isFormDisabled = false;
  isEditMode = false;
  control: any;
  authFrequencyTypeList: LookupValueItem[] = [];
  radioOptions: LookupValueItem[] = [];
  inputDiagnosisValue?: string;
  filteredDiagnosisOptions: any[] = [];
  filteredDiagnosisOptions1: any[] = [];
  filteredDiagnosisOptions2: any[] = [];
  filteredDiagnosisOptions3: any[] = [];
  override daysOfWeek: string[] = ['Sun', 'Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat'];
  minSteps = ['00', '15', '30', '45'];
  // private searchSubject = new Subject<string>();
  actionButtons: TableRowActionsModel = new TableRowActions({ add: true });
  disableDate = false;
  minStartDate?: Date;
  maxEndDate?: Date;

  @Input() formState = 'edit';
  @Input() authData: any;
  @Input() authAdded = false;
  // @Input() diagnosisCodesList: any;
  @Input() disableForm = true;
  @Input() actionMode = 'read'
  @Input() from: any;
  @Input() showConsumerMcoPlanId = false;
  @Output() authSubmitted = new EventEmitter<boolean>();
  @Output() authUpdate = new EventEmitter<boolean>();
  @ViewChild('diagnosisListDialog') diagnosisListDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  dialogId: any;
  isPatching = false;
  codeForUnits: any;
  authSourceList: any;

  @ViewChild('consumerInfoRegion') consumerInfoRegion!: ElementRef;
  @ViewChild('firstFormField') firstFormField!: ElementRef;

  planIdList = [
    {
      lkpValueName: 'Plan 1',
      lkpValueCode: 'm1',
    },
    {
      lkpValueName: 'Plan 2',
      lkpValueCode: 'm1',
    },
  ];

  svcAdminList: any;

  unitTypeList: any;

  gridData = [
    {
      consumerFirstName: 'Nikhil',
      consumerLastName: 'Peter',
      medicaid: 'PRV-NY-10000722',
      pplId: 'PPL-NY-10000733',
    },
    {
      consumerFirstName: 'Venkat',
      consumerLastName: 'Paul',
      medicaid: 'PRV-NY-10000745',
      pplId: 'PPL-NY-10000793',
    },
  ];

  constructor(
    private fb: FormBuilder,
    private sectionsService: SectionsService,
    private listService: ListService,
    private authorizationService: AuthorizationsDetailsService,
    private datePipe: DatePipe,
    private logger: LoggerService,
    private sharedService: SharedService,
    private claimsService: ClaimsService,
    private userService: UserService
  ) {
    super();
  }

  ngOnInit(): void {
    this.authorizationsForm = this.fb.group({
      consumerFirstName: [''],
      consumerLastName: [''],
      medicaid: [''],
      consumerPPLId: [''],
      pplAuth: [''],
      clientAuth: [''],
      serviceCode: [null],
      diagnosisId: [null],
      primaryDiagnosisId1: [null],
      primaryDiagnosisId2: [null],
      primaryDiagnosisId3: [null],
      diagnosisIdValue: [{value: null, disabled: true}],
      primaryDiagnosisId1Value: [{value: null, disabled: true}],
      primaryDiagnosisId2Value: [{value: null, disabled: true}],
      primaryDiagnosisId3Value: [{value: null, disabled: true}],
      planId: [null],
      serviceAdminLkp: [null],
      modifierCode1: [null],
      units: [0],
      startDate: [''],
      endDate: [''],
      orgName: [null],
      source: [null],
      decisionBy: [null],
      sourceDetail: [null],
      statusLkp: [null],
      decisionComments: [null],
      authFrequencyLkp: [null],
      carryoverUnits: [null],
      sunHrs: [null],
      monHrs: [null],
      tuesHrs: [null],
      wedHrs: [null],
      thuHrs: [null],
      friHrs: [null],
      satHrs: [null],
      dailyUnits: this.fb.array((this.createDays())
      ),
      totalAuthUnitsHrs: [null],
      totalAuthUnitsMin: ['00'],
      totalAuthUnits: [null],
      estimatedFirstWeekUnits: [null],
      estimatedMidWeekUnits: [null],
      estimatedLastWeekUnits: [null],
      weeklyAuthUnitsFormatted: [null]
    });

    const program = this.userService.getSelectedProgram();
    this.flow = this.sectionsService.getFlow() ?? '';
    this.selectedAuth = this.userService.getSelectedLead();
    this.programName = program?.program_code ?? '';
    this.secData = this.sectionsService.getSectionData(
      program?.program_code,
      'payroll'
    );
    this.getLookupValues();
    this.getServiceData();
    this.providerTypes = this.getLookup('ProviderType');
    this.svcAdminList = this.getLookup('Waiver').filter((value: any)=> value.lkpValueCode === 'Health Plan');
    this.unitTypeList = this.getLookup('Utype');
    this.authSourceList = this.getLookup('AuthS');
    this.authFrequencyTypeList = this.getLookup('AFT');
    this.radioOptions = this.getLookup('Yes_No');
    this.getGridHeaders();
    this.getAuthGridHeaders();
    this.authorizationsForm.get('endDate')?.valueChanges.subscribe(() => {
      this.updateMinStartDate();
    });
    this.authorizationsForm.get('startDate')?.valueChanges.subscribe(() => {
      this.updateMaxEndDate();
    });
    // this.authorizationsForm
    //   .get('serviceAdminLkp')
    //   ?.valueChanges.subscribe((value) => {
    //     if(!this.isPatching){
    //       this.authorizationsForm.get('orgName')?.reset();
    //       this.authorizationsForm.get('planId')?.reset();
    //     if (value !== 'Health Plan') {
    //       this.authorizationsForm.get('orgName')?.disable();
    //       this.authorizationsForm.get('planId')?.disable();
    //     } else {
    //         this.authorizationsForm.get('orgName')?.enable();
    //     }
    //   }
    //   if(this.isPatching && value !== 'Health Plan'){
    //     this.authorizationsForm.get('orgName')?.disable();
    //   }
    //   });

    if (this.disableForm) {
      this.authorizationsForm.disable();
      this.disableDate = true;
      this.getSelectedAuthDetails();
    }
    if (this.mode === 'edit') {
      this.disableFieldsForEdit();
      this.getSelectedAuthDetails();
    }
    this.authorizationService.getDocUpload().subscribe((docUpload: any) => {
      if (docUpload) {
        // this.authorizationsForm.reset();
        this.authorizationsForm.disable();
        this.disableDate = true;
      }
    });
  }

  // ngAfterViewInit() {
  //   const heading = document.getElementById('step1-header');
  //   if (heading) {
  //     heading.focus();
  //   }
  // }
  onInputBlur(val?: string, event?:any, i?: number, day?: any){
    const dailyHours = this.authorizationsForm.get('dailyUnits')?.value;
    // const codeSelected = this.authorizationsForm.get('serviceCode')?.value;
      let totalUnits = 0;
      dailyHours.forEach((entry:any) => {
        const hoursUnits = entry.hours * 4;
        const minutesUnits = entry.minutes ? entry.minutes / 15 : 0;
        totalUnits += hoursUnits + minutesUnits;
      });
      // if (this.codeForUnits?.includes(codeSelected)) {
      //   this.authorizationsForm.get('units')?.setValue(26);
      // } else {
        this.authorizationsForm.get('units')?.setValue(totalUnits);
      // }
  }

  serviceCodeChanged(event: any){
    if(!this.isPatching){
      const service = this.serviceCodesList.filter((code: any)=> code.servicecodeDetailId === event);
      this.authorizationsForm.get('modifierCode1')?.setValue(service[0]?.modifierDetailId);
      // const allEmpty = this.authorizationsForm.get('dailyUnits')?.value?.every((item: any) => (!item.hours || item.hours === '00') && (!item.minutes || item.minutes === '00'));
      // if(this.codeForUnits?.includes(event)){
      //   if( !allEmpty || this.authorizationsForm.get('totalAuthUnitsHrs')?.value || this.authorizationsForm.get('totalAuthUnitsMin')?.value !== '00'){
      //     this.authorizationsForm.get('units')?.setValue(26);
      //   }
      // }
      // else{
      //   if(!allEmpty){
      //     this.onInputBlur();
      //   }
      //   else{
      //     const authHr = this.authorizationsForm.get('totalAuthUnitsHrs')?.value || 0;
      //     const authMin = this.authorizationsForm.get('totalAuthUnitsMin')?.value || 0;
      //     const totalAuthUnits = authHr?.toString().padStart(2, '0') + authMin?.toString().padStart(2, '0');
      //     const totalUnits = this.timeToUnits(totalAuthUnits);
      //     this.authorizationsForm.get('units')?.setValue(totalUnits);
      //   }
      // }
    }
  }

  authFreqChanged(){
    if(this.authorizationsForm.get('totalAuthUnitsHrs')){
      this.authorizationsForm.get('totalAuthUnitsHrs')?.reset();

    }
    if(!this.isPatching) {
      this.authorizationsForm.get('units')?.setValue(0);
      this.authorizationsForm.get('totalAuthUnitsMin')?.setValue('00');
      const dailyUnitsArray = this.authorizationsForm.get('dailyUnits') as FormArray;
    
      dailyUnitsArray.controls.forEach((control, index) => {
        if (control instanceof FormGroup) {
          control.get('hours')?.reset();
          control.get('minutes')?.setValue('00');
        }
      });
      //this.authorizationsForm.get('dailyUnits')?.reset();
    }
  }

  getServiceData(){
    this.claimsService.getServiceData(this.programName).subscribe((data:any)=>{
      this.serviceCodesList = data?.responsedata?.serviceCodes;
      this.mcoEntries = data?.responsedata?.organizations;
      this.codeForUnits = this.serviceCodesList.filter((codeData:any)=> codeData.description.includes('T1020')).map((code:any)=> code.servicecodeDetailId);
    })
  }

  createDays(): FormGroup[] {
    if(this.from === 'add' || this.mode === 'edit') {
      return this.daysOfWeek.map(() => {
        const dayGroup = this.fb.group({
          hours: ['', [Validators.min(0), Validators.max(24), Validators.pattern('^[0-9]*$')]],
          minutes: ['00']
        });
        
          dayGroup.get('hours')?.valueChanges.subscribe((hours) => {
            const minutesControl = dayGroup.get('minutes');
            const hoursNumber = Number(hours);
      
            if (hoursNumber === 24) {
              minutesControl?.setValue('00');
              minutesControl?.disable();
            } else {
              if(this.disableForm && this.from === 'details') {
                minutesControl?.disable();
              } else {
                minutesControl?.enable();
              }
            }
          });
        return dayGroup;
      });
    }
    return this.daysOfWeek.map(() => {
      return this.fb.group({
        hours: [''],
        minutes: ['']
      });
    })
  }

  getControlClass(i: number): string {
    const dailyUnits = this.authorizationsForm.get('dailyUnits') as FormArray;
    const hoursControl = dailyUnits.controls[i]?.get('hours');
    
    if (!hoursControl) return '';
  
    if (hoursControl.invalid && hoursControl.touched) {
      return 'ng-invalid-hours';
    } else if (hoursControl.valid) {
      return 'ng-valid-hours';
    }
    return '';
  }

  get dailyUnits(): FormArray {
    return this.authorizationsForm.get('daysToContact') as FormArray;
  }

  getLookupValues(): void {
    this.modifiersList = this.lookupService.getTasLookupValue('modifierDetailList');
  }

  onOrgChange(event: any){
    if(event){
      const planId = this.mcoEntries.find((org: any)=>{
        return org.orgId === event;
      })
      this.authorizationsForm.get('planId')?.setValue(planId?.payerId)
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    try {
      if (changes['formState'] && changes['formState'].currentValue) {
        this.mode = changes['formState'].currentValue;
      }
      if (changes['from'] && changes['from'].currentValue) {
        if (this.from === 'add' && this.authorizationsForm) {
          this.authorizationsForm.enable();
          this.disableDate = false;
        }
      }
      if (changes['authData'] && changes['authData'].currentValue) {
        this.getSelectedAuthDetails();
      }
      // if(changes['diagnosisCodesList'] && changes['diagnosisCodesList'].currentValue) {
      //   this.getSelectedAuthDetails();
      // }
      if (
        changes['disableForm'] &&
        changes['disableForm'].currentValue !==
          changes['disableForm'].previousValue
      ) {
        if (this.disableForm && this.authorizationsForm) {
          this.authorizationsForm.disable();
          this.disableDate = true;
          this.getSelectedAuthDetails();
        } else if (!this.disableForm && this.authorizationsForm) {
          this.mode = 'edit';
          this.authorizationsForm.enable();
          this.disableDate = false;
          this.disableFieldsForEdit();
          this.getSelectedAuthDetails();
        }
      }
    } catch (e) {
      console.log('Error in getting section data and updating latest info', e);
    }
  }

  onAuthUnitMinChange(event: any){
    if(event) {
      let authHr = this.authorizationsForm.get('totalAuthUnitsHrs')?.value;
      // const codeSelected = this.authorizationsForm.get('serviceCode')?.value;
      if(!authHr && event){
        authHr = 0;
      }
      const totalAuthUnits = authHr.toString().padStart(2, '0') + event?.toString().padStart(2, '0');
      this.authorizationsForm.get('totalAuthUnits')?.setValue(totalAuthUnits);
      const totalUnits = this.timeToUnits(totalAuthUnits);
      // if (this.codeForUnits?.includes(codeSelected)) {
      //   this.authorizationsForm.get('units')?.setValue(26);
      // } else {
        this.authorizationsForm.get('units')?.setValue(totalUnits);
      // }
    }
  }

  onAuthUnitHrChange(event: any){
    if(event || event === 0) {
      let authMin = this.authorizationsForm.get('totalAuthUnitsMin')?.value;
      // const codeSelected = this.authorizationsForm.get('serviceCode')?.value;
      if(!authMin && event){
        authMin = 0;
      }
      const totalAuthUnits = event?.toString().padStart(2, '0') + authMin?.toString().padStart(2, '0');
      this.authorizationsForm.get('totalAuthUnits')?.setValue(totalAuthUnits);
      const totalUnits = this.timeToUnits(totalAuthUnits);
      // if (this.codeForUnits?.includes(codeSelected)) {
      //   this.authorizationsForm.get('units')?.setValue(26);
      // } else {
        this.authorizationsForm.get('units')?.setValue(totalUnits);
      // }
  }
  }

  limitDigits(event: any): void {

    let value = event.target.value.replace(/[^0-9]/g, '');
      event.target.value = value;
      this.authorizationsForm.get('totalAuthUnitsHrs')?.setValue(value);
  }

  limitDailyDigits(event: any): void {

    let value = event.target.value.replace(/[^0-9]/g, '');
      event.target.value = value;
  }

  timeToUnits(time: string): number {
    if(time){
      const minutes = parseInt(time.slice(-2), 10);
      const hours = parseInt(time.slice(0, -2), 10);
      const totalMinutes = (hours * 60) + minutes;
      const units = Math.floor(totalMinutes / 15);
      return units;
    }
    else{
      return 0;
    }
  }

  getSelectedAuthDetails() {
    // API call to fetch the details and patch form
    this.isPatching = true;
    console.log('auth data', this.authData, this.authData?.primaryDiagnosisId1Value);
    const totalUnits = this.authData?.totalAuthUnits;
    let totalHrs = 0;
    let totalMins = '00';
    if (totalUnits?.includes(':')) {
      const [hrs, mins] = totalUnits.split(':');
      totalHrs = parseInt(hrs, 10);
      totalMins = mins;
    } else if (totalUnits) {
      totalMins = totalUnits.slice(-2);
      totalHrs = totalUnits.length > 2 ? parseInt(totalUnits.slice(0, -2), 10) : 0;
    }
    if(this.authorizationsForm !== undefined && this.authData?.authFrequencyLkp === 'Daily') {
    const dailyUnitsArray = this.authorizationsForm.get('dailyUnits') as FormArray;
    this.daysOfWeek.forEach((day, index) => {
      const apiKey = `${day.toLowerCase()}Hrs`;
      const timeString = this.authData[apiKey];
      if (timeString !== null && timeString !== undefined) {
        let totalMins = '00';
        let totalHrs = '0';
        const timeStr = timeString.toString().replace(':', '');
        if (timeStr.length === 1 || timeStr.length === 2) {
          totalHrs = '00';
          totalMins = timeStr.padStart(2, '0');
        }
        else if (timeStr.length >= 3) {
          totalHrs = timeStr.slice(0, -2);
          totalMins = timeStr.slice(-2);
        }

        const formGroup = dailyUnitsArray.at(index) as FormGroup;
        formGroup.patchValue({
          hours: totalHrs,
          minutes: totalMins
        });
      }
    });
  }

  const weeklyUnits = this.authData?.weeklyAuthUnits?.split(":");

    const formValuesToPatch = {
      ...this.authData,
      diagnosisIdValue: this.authData?.diagnosisValue,
      primaryDiagnosisId1Value: this.authData?.diagnosisValue1,
      primaryDiagnosisId2Value: this.authData?.diagnosisValue2,
      primaryDiagnosisId3Value: this.authData?.diagnosisValue3,
      serviceCode: this.authData?.serviceCodeId,
      planId: this.authData?.planIdLkp,
      modifierCode1: this.authData?.modifier1,
      // startDate: this.authData?.startDate ? new Date(this.authData?.startDate + 'T00:00:00') : null,
      // endDate: this.authData?.endDate ? new Date(this.authData?.endDate + 'T00:00:00') : null,
      orgName: this.authData?.orgId,
      units: this.authData?.units,
      carryoverUnits:
        this.authData?.carryoverUnits === true
          ? 'Yes'
          : this.authData?.carryoverUnits === false
          ? 'No'
          : this.authData?.carryoverUnits,
    };

    this.authorizationsForm?.patchValue(formValuesToPatch);

    var val = this.authorizationsForm?.get("weeklyAuthUnitsPartB")?.value;
    if(this.authData?.totalAuthUnits && this.authData?.totalAuthUnits != '0000') {
      this.authorizationsForm?.patchValue({
        totalAuthUnitsHrs: totalHrs ?? 0,
        totalAuthUnitsMin: totalMins ?? '00'
      })
    }
    this.isPatching = false;
  }

  updateMinStartDate(): void {
    const endDate = this.authorizationsForm.get('endDate')?.value;
    if (endDate instanceof Date) {
      const nextDay = new Date(endDate);
      nextDay.setDate(nextDay.getDate() - 1);
      this.minStartDate = nextDay;
    } else {
      this.minStartDate = undefined;
    }
  }

  updateMaxEndDate(): void {
    const startDate = this.authorizationsForm.get('startDate')?.value;
    if (startDate instanceof Date) {
      const nextDay = new Date(startDate);
      nextDay.setDate(nextDay.getDate() + 1);
      this.maxEndDate = nextDay;
    } else {
      this.maxEndDate = undefined;
    }
  }

  disabledStartDate = (startValue: Date): boolean => {
    const endDate = this.authorizationsForm.get('endDate')?.value;
    if (!startValue || !endDate || !(endDate instanceof Date)) {
      return false;
    }
    console.log("startval", startValue, endDate,endDate instanceof Date,  startValue.getTime() > endDate.getTime())

    return startValue.getTime() > endDate.getTime();
  };

  disabledEndDate = (endValue: Date): boolean => {
    const startDate = this.authorizationsForm.get('startDate')?.value;
    if (!endValue || !startDate || !(startDate instanceof Date)) {
      return false;
    }
    return endValue.getTime() <= startDate.getTime();
  };

  disableFieldsForEdit() {
    const fieldsToKeepDisabled = [
      'modifierCode1',
      'authFrequencyLkp',
      'serviceAdminLkp',
    ];
    this.isEditMode = true;
    const formControls = Object.keys(this.authorizationsForm.controls);

    formControls.forEach((control) => {
      if (fieldsToKeepDisabled.includes(control)) {
        this.authorizationsForm.get(control)?.disable();
      }
    });
}

  diagnosisCodeSelected(data: any){
    if (this.dialogId) {
      this.dialogSvc.closeDialog(this.dialogId);
      this.dialogId = null;
    }
    const codeValue = `${data.control}Value`
    this.authorizationsForm.get(codeValue)?.setValue(data.code?.description);
    this.authorizationsForm.get(data.control)?.setValue(data.code?.diagnosisDetailId);
  }

  openSearchDisgnosisCodePopup(code: string){
    this.control = code;
    const dialogConfig: DialogConfig = {
          title: 'Search Diagnosis Code',
          isOkText: 'Ok',
          size: 'large',
          position: 'top',
          showClose: true,
          showButtons: false,
        };
    
      this.dialogId =  this.dialogSvc.openDialog(
          this.diagnosisListDialog,
          dialogConfig,
          () => this.handleCancel(),
          () => this.handleCancel()
        );
  }

  handleCancel(){

  }

  onConsumerSearch() {
    const formData = this.authorizationsForm.value;
    const from = '';
    console.log('formData', formData);
    this.showSearchError = !(
      formData.consumerFirstName.trim() !== '' ||
      formData.consumerLastName.trim() !== '' ||
      formData.medicaid.trim() !== '' ||
      formData.consumerPPLId.trim() !== ''
    );
    // this.showConsumersList = !this.showSearchError;
    if (!this.showSearchError) {
      const payload = this.buildRequestPayload();
      this.listService.getListData(payload, from).subscribe((data: any) => {
        console.log('search data', data);
        this.gridData = data.responsedata;
        this.gridData.forEach((consumer: any) => {
          consumer['arialabel'] = `${consumer.consumerFirstName} ${consumer.consumerLastName} - CIN: ${consumer.medicaid} - PPL ID: ${consumer.consumerPPLId}`
        });
        this.showConsumersList = true;
        setTimeout(() => {
          const step2Header = document.getElementById('step2-header');
          if (step2Header) {
            step2Header.focus();
          }
        }, 0);
      });
    }
  }

  buildRequestPayload(event?: any) {
    const formData = this.authorizationsForm.value;
    const payload: any = {
      pageName: 'consumer-search',
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: event ? (event?.startingPageNumber).toString() : '1',
      searchParam: [],
      orderByColumn: [],
      orderBy: [],
    };
    let searchParams = [];
    if (formData.consumerFirstName) {
      searchParams.push({
        jsonPath: 'consumerFirstName',
        value: formData.consumerFirstName.trim(),
        operator: 'equal',
      });
    }

    if (formData.consumerLastName) {
      searchParams.push({
        jsonPath: 'consumerLastName',
        value: formData.consumerLastName.trim(),
        operator: 'equal',
      });
    }

    if (formData.medicaid) {
      searchParams.push({
        jsonPath: 'medicaid',
        value: formData.medicaid.trim().toUpperCase(),
        operator: 'equal',
      });
    }

    if (formData.consumerPPLId) {
      searchParams.push({
        jsonPath: 'consumerPPLId',
        value: formData.consumerPPLId.trim(),
        operator: 'equal',
      });
    }
    payload.searchParam = searchParams;
    return payload;
  }

  async getGridHeaders() {
    try {
      if (this.flow) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.AUTHORIZATIONS_CONSUMER_LIST_HEADERS,
          this.flow
        );
        console.log(tempCols.columns);
        this.cols = tempCols.columns;
      }
    } catch (e) {}
  }

  async getAuthGridHeaders() {
    try {
      if (this.flow) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.AUTHORIZATIONS_LIST_HEADERS,
          this.flow
        );
        console.log(tempCols.columns);
        this.authCols = tempCols.columns;
      }
    } catch (e) {}
  }

  onConsumerSelect() {}

  action(event: GridAction) {
    console.log('event');
    if (event && event.action === 'add') {
      console.log(event.data);
      this.selectedConsumer = event.data;
      this.isConsumerSelected = true;
      this.mode = 'add';
      this.showConsumersList = false;

      if (this.consumerInfoRegion) {
        this.consumerInfoRegion.nativeElement.focus();
  
        // Wait 2.5 seconds for NVDA to read all headings and read-only fields
        setTimeout(() => {
          if (this.firstFormField) {
            this.firstFormField.nativeElement.focus();
          }
        }, 2500); // adjust delay if needed
      }
      // setTimeout(() => {
      //   const step3Header = document.getElementById('step3-header');
      //   if (step3Header) {
      //     step3Header.focus();
      //   }
      // }, 0);
    }
  }

  onCancelUser() {
    this.isConsumerSelected = false;
    this.selectedConsumer = {};
    this.authorizationsForm.reset();
    this.showAddedAuths = false;
    this.authsInSession = [];
  }

  onAdd() {
    this.saveAuthDetails();
  }

  populateDays(dailyHrs: any) {
    this.daysOfWeek.forEach((day, i) => {
      const hours = dailyHrs[i]?.hours || '00';
      const minutes = dailyHrs[i]?.minutes || '00';
      const timeValue = `${hours.toString()?.padStart(2, '0')}${minutes.toString()?.padStart(2, '0')}`;
      this.authorizationsForm.get(`${day.toLowerCase()}Hrs`)?.setValue(timeValue);
    });
  }

  handleAuthorization(formData: any, submitMode: string) {
    let allEmpty = false;
    let noUnits = false;
    const dailyUnits = this.authorizationsForm.get('dailyUnits') as FormArray;
    let hasInvalidHours = false;

    if (formData.authFrequencyLkp === 'Daily') {
      for (let control of dailyUnits.controls) {
        const hoursControl = control.get('hours');
    
        if (hoursControl && hoursControl.invalid) {
          hasInvalidHours = true;
          break;
        }
      }
        allEmpty = formData?.dailyUnits?.every((item: any) => (!item.hours || item.hours === '00' || item.hours === '0') && (!item.minutes || item.minutes === '00'));
    } else {
        noUnits = (formData.totalAuthUnits === undefined || formData.totalAuthUnits === null || formData.totalAuthUnits === '0000' || isNaN(formData.totalAuthUnits));
    }

    try {
        this.validationErrors = performValidation(formData, this.secData, 'Submit', undefined, undefined, this.sectionsService.getFlow(), this.sectionsService.getEnrollmentType());
        let newError: any = {};
        if (allEmpty) {
            newError.unitsInFormatDaily = 'Please enter units for atleast one day';
        }
        if (noUnits) {
            newError.unitsInFormat = 'Please enter Units';
        }
        if(hasInvalidHours){
          newError = {
            unitsInFormatDaily: 'Please enter upto 24 hours'
          }
        }
        this.validationErrors = {
            ...this.validationErrors,
            ...newError
        };

        console.log('validationErrors', this.validationErrors);
    } catch (e) {
        this.logger.debug('Error in validations', e);
    }
    if (Object.keys(this.validationErrors).length === 0) {
        const payload: any = {
            ...formData,
            clientAuth: formData.clientAuth.trim(),
            unittypeLkp: 'HR',
            startDate: this.datePipe.transform(formData.startDate, 'yyyy-MM-dd'),
            endDate: this.datePipe.transform(formData.endDate, 'yyyy-MM-dd'),
            modifier1: formData.modifierCode1,
            orgId: formData.orgName,
            billableRate: 0,
            planIdLkp: formData.planId,
            carryoverUnits: formData.carryoverUnits === 'Yes' ? true : formData.carryoverUnits === 'No' ? false : formData.carryoverUnits,
        };
          this.daysOfWeek.forEach(day => {
            const key = `${day.toLowerCase()}Hrs`;
            payload[key] = this.formatHrs(formData[key]);
          });
          payload.totalAuthUnits = this.formatHrs(formData.totalAuthUnits);

        if (submitMode === 'save') {
            payload.participantId = this.selectedConsumer.participantId;
            payload.medicaidId = this.selectedConsumer.medicaid;
            this.saveAuthorization(payload);
        } else if (submitMode === 'update') {
            payload.authorizationId = this.selectedAuth;
            this.updateAuthorization(payload);
        }
    } else {
        return;
    }
}

formatHrs(hours: string): string {
  if (hours.length === 4) {
    return hours.slice(0, 2) + ":" + hours.slice(2);
  }
  return hours;
}

saveAuthorization(payload: any) {
    this.authorizationService
        .saveAuthorization(this.programName, payload, true)
        .subscribe((data: any) => {
          console.log('saved auth', data);
          this.savedAuthId = data.responsedata.authorizationId;
          if (data.status == 200) {
            this.authSubmitted.emit(true);
            setTimeout(() => {
              const step4Header = document.getElementById('step4-header');
              if (step4Header) {
                step4Header.focus();
              }
            }, 0);
          }
        });
}

  updateAuthorization(payload: any) {
    this.authorizationService
        .updateAuthorizationDetails(this.programName, this.selectedAuth, payload)
        .subscribe((data: any) => {
            console.log('updated auth', data);
            this.authData = data.responsedata;
            this.getSelectedAuthDetails();
            this.onCancelUpdate();
        });
  }

  saveAuthDetails() {
    const dailyHrs = this.authorizationsForm.get('dailyUnits')?.value;
    const dailyUnits = this.authorizationsForm.get('dailyUnits') as FormArray;
    this.populateDays(dailyHrs);
    const authData = this.authorizationsForm.getRawValue();
    const { diagnosisIdValue, primaryDiagnosisId1Value, primaryDiagnosisId2Value, primaryDiagnosisId3Value, ...formData} = authData;
    const data = { ...this.authorizationsForm.value };

    data.startDate = this.dateFormatter.formatToString(data.startDate);

    if (data.endDate) {
      data.endDate = this.dateFormatter.formatToString(data.endDate);
    }
    this.handleAuthorization(formData, 'save');
}

  onCancelUpdate() {
    this.validationErrors = {};
    this.authUpdate.emit(true);
  }

  onUpdate() {
    const dailyHrs = this.authorizationsForm.get('dailyUnits')?.value;
    this.populateDays(dailyHrs);
    const formData = this.authorizationsForm.getRawValue();
    this.handleAuthorization(formData, 'update');
}

  viewerValueChange(value: string) {
    const viewerValue = [value][0];
  }

  filesUpdated() {
    console.log('Files List update');
    this.getDocumentsUploaded(true);
  }

  getDocumentsUploaded(hasUpdatedEntry?: boolean) {
    this.sharedService
      .getUploadedFileDetails(
        this.programName,
        this.savedAuthId,
        'auth',
        hasUpdatedEntry
      )
      .subscribe((data: any) => {
        console.log(data);
        this.filedInfo = data?.responsedata;
      });
  }
}
